module.exports = __webpack_public_path__ + "img/9d363de.jpg";